module.exports = __webpack_public_path__ + "media/images/woman-success-57b211ca4d377c06b7d780219b1fe2af.png";